import { useMemo } from 'react';
import { useDataFetchingClient } from 'data-fetching-client';
import useFetchFromCRM from 'framework-listing-lib/internal/hooks/useFetchFromCRM';
import { UNFILED_ASSETS_ID } from 'framework-listing-lib/internal/Folders/constants/folders';
import { getHasUnfiledAssetsCache } from 'framework-listing-lib/internal/Folders/utils/unfiledAssets';
import useUnfiledAssetVariables from 'framework-listing-lib/internal/Folders/hooks/useUnfiledAssetVariables';
import useMaybeApolloClient from './useMaybeApolloClient';
export default function useFetchUnfiledAssets(folderId) {
  const variables = useUnfiledAssetVariables();
  const client = useDataFetchingClient();
  const maybeApolloClient = useMaybeApolloClient();
  const hasUnfiledAssetsCache = useMemo(() => getHasUnfiledAssetsCache({
    dfcClient: client,
    maybeApolloClient,
    variables
  }), [client, maybeApolloClient, variables]);
  useFetchFromCRM(variables, {
    skip: hasUnfiledAssetsCache || folderId === UNFILED_ASSETS_ID
  });
}